import { ReactNode } from 'react';

import { MenuWrapper } from '@vk-hr-tek/app-ui/MenuWrapper';

interface BellMenuProps {
  anchorEl: HTMLElement | null;
  id?: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export const BellMenu = (props: BellMenuProps) => {
  return (
    <MenuWrapper
      anchorOrigin={{
        vertical: 40,
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      width={462}
      {...props}
    >
      {props.children}
    </MenuWrapper>
  );
};
